import { Key } from '@briebug/ngrx-auto-entity';

export class SubcontractorVendor {
  @Key id?: number;
  vendor: string;
  vendorName?: string;
  categories: number[];
}
